import { captureException } from "@/helpers/sentry"
import { IHeroMeResponse } from "@/store/apis/heroAPI/hero.types"

export const reportUnparsableServerTime = (
  response: IHeroMeResponse
): IHeroMeResponse => {
  if (Number.isNaN(Date.parse(response.serverTime))) {
    captureException(new Error("GET /hero/me: serverTime does not parse"), {
      serverTime: response.serverTime
    })
  }
  return response
}
